import React from 'react';
export function HeroSection() {
  return <section className="w-full py-16 md:py-24 px-4 bg-warm-cream flex flex-col items-center justify-center text-center" data-id="element-77">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-78">
        <h1 className="md:text-5xl lg:text-6xl font-heading font-bold mb-6 text-[48px] text-[#B55B37] hero-fade-in" data-id="element-79">
          "Método Mesa en Paz"
        </h1>

        <p className="text-lg md:text-xl italic font-medium text-secondary-coral mb-8 max-w-2xl hero-fade-in hero-delay-1" data-id="element-80">
          ¿Cuántas cenas más vas a terminar en llanto, gritos o con la tablet
          encendida rezando para que tu hijo coma algo?
        </p>

        <div className="w-full max-w-2xl mb-12 relative" data-id="element-81">
          <img src="https://cdn.magicpatterns.com/uploads/3Atpf6s1M3vQ51aGZJxYf8/lolo.png" alt="Método Mesa en Paz - Guía completa para familias con niños selectivos con la comida" width={800} height={800} loading="eager" decoding="sync" fetchPriority="high" className="w-full h-auto object-contain" data-id="element-82" />
        </div>

        <div className="text-lg md:text-xl text-text-body max-w-2xl space-y-2 hero-fade-in hero-delay-2" data-id="element-83">
          <p data-id="element-84">Hay familias que disfrutan la cena juntos.</p>
          <p data-id="element-85">Y hay familias que la sobreviven.</p>
          <p className="font-bold text-text-heading mt-4 text-xl" data-id="element-86">
            La diferencia es un método.
          </p>
        </div>
      </div>
    </section>;
}